import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomValuesService } from '@core/services/custom-values.service';
import { EDeliverableType } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsStatusBadgeComponent } from '@shared/components/analytics-status-badge/analytics-status-badge.component';
import { CustomRemoveButtonComponent } from '@shared/components/custom-remove-button/custom-remove-button.component';
import { EditableTitleComponent } from '@shared/components/editable-title/editable-title.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { DeliverableAdvancedButtonComponent } from '../advanced-button/deliverable-advanced-button.component';
import { DeliverableAdvancedSettingsSectionComponent } from '../advanced-settings-section/deliverable-advanced-settings-section.component';
import { TextDeliverableComponent } from '../shared/text-deliverable/text-deliverable.component';
import { ITextDeliverableConfig } from '../shared/text-deliverable/text-deliverable.interface';

@Component({
  imports: [
    DeliverableAdvancedButtonComponent,
    DeliverableAdvancedSettingsSectionComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatErrorComponent,
    MatTooltipModule,
    MatCheckboxModule,
    MatRadioModule,
    EditableTitleComponent,
    MatExpansionModule,
    IconComponent,
    CustomRemoveButtonComponent,
    AnalyticsStatusBadgeComponent,
  ],
  selector: 'app-title',
  templateUrl: '../shared/text-deliverable/text-deliverable.component.html',
})
export class TitleComponent extends TextDeliverableComponent {
  constructor(customValuesService: CustomValuesService) {
    super(customValuesService);
  }

  protected override getConfigOverrides(): Partial<ITextDeliverableConfig> {
    return {
      addButtonTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.titleDeliverable.addKeyword',
      highlightNamespace: 'titleContent',
      lastActiveCannotBeDeletedTranslationKey:
        'pages.campaignForm.ctaDialog.ctaDetails.deliverables.titleDeliverable.lastActiveTitleCannotBeDeleted',
      placeholderTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.titleDeliverable.placeholder',
      subtitleTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.titleDeliverable.subtitle',
      type: EDeliverableType.title,
    };
  }
}
